<ion-card mode="ios">
  <ion-card-header class="margin-bottom-s ion-no-padding">
    <ion-card-title color="getm-neutral-dark" class="margin-bottom-s">{{
      'Labels.order-details' | translate
    }}</ion-card-title>
  </ion-card-header>

  <ion-card-content class="ion-no-padding">
    <ion-list mode="ios">
      <!-- Total de cajas -->
      <ion-item lines="none" class="margin-bottom-s">
        <ion-grid>
          <ion-row class="ion-align-items-center">
            <ion-col size="auto" class="icon-wrapper">
              <ion-icon name="getm-box-outline" class="native-icon"></ion-icon>
            </ion-col>
            <ion-col>
              <ion-label class="label-item">{{
                'Labels.total-cases' | translate
              }}</ion-label>
            </ion-col>
            <ion-col size="auto">
              <ion-label class="label-item-bold">{{ totalBoxes }}</ion-label>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>

      <!-- Ahorro -->
      <ion-item lines="none" class="margin-bottom-s">
        <ion-grid>
          <ion-row class="ion-align-items-center">
            <ion-col size="auto" class="icon-wrapper">
              <ion-icon
                name="getm-discount-outline"
                class="native-icon orange"
              ></ion-icon>
            </ion-col>
            <ion-col>
              <ion-label class="label-item">{{
                'Labels.you-will-save' | translate
              }}</ion-label>
            </ion-col>
            <ion-col size="auto">
              <ion-label
                color="getm-secondary-default"
                class="label-item-bold"
                >{{
                  savings | currency : 'MXN' : 'symbol-narrow' : '1.2-2'
                }}</ion-label
              >
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>

      <!-- Total a pagar -->
      <ion-item lines="none" class="margin-bottom-s">
        <ion-grid>
          <ion-row class="ion-align-items-center">
            <ion-col size="auto" class="icon-wrapper">
              <ion-icon
                name="getm-document-outline"
                class="native-icon"
              ></ion-icon>
            </ion-col>
            <ion-col>
              <ion-label class="label-item">{{
                'Labels.total-to-pay' | translate
              }}</ion-label>
            </ion-col>
            <ion-col size="auto">
              <ion-label class="label-item-bold">{{
                totalToPay | currency : 'MXN' : 'symbol-narrow' : '1.2-2'
              }}</ion-label>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-item>

      <ng-container *ngIf="pointsToWin > 0 || totalFavs > 0">
        <ion-item-group class="item-group-points margin-bottom-s">
          <!-- Puntos a ganar -->
          <ng-container *ngIf="pointsToWin > 0">
            <ion-item mode="md" color="getm-neutral-white" lines="none">
              <ion-icon
                slot="start"
                name="getm-pepsi-point"
                color="getm-primary-default"
                class="custom-icon"
              ></ion-icon>

              <ion-label class="label-item">
                {{ 'Labels.points-to-win' | translate }}
              </ion-label>

              <ion-text class="label-item-bold ion-float-right">
                {{ pointsToWin | number : '1.0-0' }}
              </ion-text>
            </ion-item>
          </ng-container>

          <!-- Favs Agregados -->
          <ng-container *ngIf="totalFavs > 0">
            <ion-item mode="md" color="getm-neutral-white" lines="none">
              <ion-icon
                slot="start"
                name="getm-fav"
                color="getm-category-gana-mas"
                class="custom-icon"
              ></ion-icon>

              <ion-label class="label-item">
                {{ 'Labels.favorites' | translate }}
              </ion-label>

              <ion-text class="label-item-bold ion-float-right">
                {{ totalFavs | number : '1.0-0' }}
              </ion-text>
            </ion-item>
          </ng-container>

          <ion-item
            mode="md"
            color="getm-neutral-white"
            lines="none"
            class="ion-text-center"
          >
            <ion-label
              class="label-item-info"
              [translateFormatter]="
                'Labels.points-to-win-disclaimer' | translate
              "
            >
            </ion-label>
          </ion-item>
        </ion-item-group>
      </ng-container>

      <!-- Cuadrito azul -->
      <ion-item
        lines="none"
        class="padding-l info-blue margin-bottom-s"
        *ngIf="disclaimers && disclaimers.length > 0"
      >
        <ion-grid>
          <ion-row>
            <ng-container
              *ngFor="let disclaimer of disclaimers; let last = last"
            >
              <ion-col
                size="12"
                class="info-label"
                [ngClass]="{ 'margin-bottom-s': !last }"
              >
                <ion-text> {{ disclaimer.icon }} </ion-text>
                <ion-text
                  [innerHTML]="
                    'Labels.' + disclaimer.disclaimer
                      | translate : { deliveryDate: deliveryDateTime }
                      | htmlSeguro
                  "
                ></ion-text>
              </ion-col>
            </ng-container>
          </ion-row>
        </ion-grid>
      </ion-item>
      <!-- Cuadrito amarillo (solo cuando ya se hizo la orden) -->
      <ng-container *ngIf="isOrderConfirmed">
        <ion-item lines="none" class="padding-l info-yellow margin-bottom-s">
          <ion-grid>
            <ion-row>
              <ion-col size="12" class="info-label">
                <ion-text>
                  {{ 'Labels.modify-cancel-order-from-icon' | translate }}
                </ion-text>
                <ion-text
                  [innerHTML]="
                    'Labels.modify-cancel-order-from'
                      | translate : { limitDate: limitDate }
                      | htmlSeguro
                  "
                ></ion-text>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-item>
      </ng-container>
      <!-- Disclaimer final -->
      <ion-item lines="none" class="ion-no-padding">
        <ion-label class="ion-no-padding ion-text-center disclaimer">{{
          'Labels.order-disclaimer' | translate
        }}</ion-label>
      </ion-item>
    </ion-list>
  </ion-card-content>
</ion-card>
